import React from "react";
import { IconButton } from "material-ui";

export default function withBasicIconButton(Component) {
    return function(props) {
        return (
            <IconButton
                style={{
                    width: '40px',
                    height: '40px',
                    padding: 0
                }}
            >
                <Component { ...props } />
            </IconButton>
        ); 
    }
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/BasicIconButton.jsx